<template>
  <div class="contact">
    <div class="container-white">
      <div class="container-image">
        <p class="user-name">{{ userName }}</p>
      </div>
      <div>
        <h2>{{ name }}</h2>
        <template v-if="isLogged">
          <button v-if="!isContact" @click="addContact" :aria-label="$t('sharedDrive.addContact')" :title="$t('sharedDrive.addContact')">
            <user-plus-icon size="1.5x" class="custom-class"></user-plus-icon>
            <span>{{ $t('sharedDrive.addContact') }}</span>
          </button>
          <div v-else class="container-active-contact">
            <div class="active-contact">
              <user-check-icon size="1.5x" class="custom-class"></user-check-icon>
              <span>{{ $t('sharedDrive.activeContact') }}</span>
            </div>
            <button @click="removeContact" :aria-label="$t('sharedDrive.removeContact')" :title="$t('sharedDrive.removeContact')">
              <trash-2-icon size="1.5x" class="custom-class"></trash-2-icon>
            </button>
          </div>
        </template>
      </div>
    </div>
    <div class="container-blue">
      <img src="/img/icons/Contacts/link-vector.svg">
      <h2>{{ $t('sharedDrive.contactsFor') }}</h2>
      <h3>{{ $t('sharedDrive.shareClick') }}</h3>
      <p v-html="$t('sharedDrive.shareClickText')"></p>
      <h3>{{ $t('sharedDrive.sendMails') }}</h3>
      <p v-html="$t('sharedDrive.sendMailsText')"></p>
    </div>
  </div>
</template>

<script>

import { UserPlusIcon, UserCheckIcon, Trash2Icon } from 'vue-feather-icons';
import { mapGetters } from 'vuex';

export default {
  name: 'contact-account',
  data: function () {
    return {
      userName: '',
      name: '',
      isContact: false,
      accountHandle: '',
      contactHandle: ''
    };
  },
  components: {
    UserPlusIcon,
    UserCheckIcon,
    Trash2Icon
  },
  async mounted() {
    let link = 'https://iberbox.com/' + this.$route.path;
    let action = await ibb.getPublicAccountInfoByLink(link); 
    this.name = action.name;
    let fullName = this.name.split(' ');
    this.accountHandle = action.accountHandle;
    for (let name of fullName) {
      this.userName = this.userName + name.substr(0, 1);
    }
    if (this.isLogged) {
      this.fetchData();
    }
  },
  computed: {
    ...mapGetters([ 'isLogged' ]),
  },
  methods: {
    async fetchData() {
      this.isContact = false;
      let action = await ibb.getRootNode(Module.NodeType.CONTACT_ROOT.value);
      const {nodeList} = await ibb.getChildren(action.node.handle);
      for (let contact of nodeList) {
        if (contact.accountHandle === this.accountHandle) {
          this.contactHandle = contact.handle;
          this.isContact = true;
          return;
        }
      }
    },
    async addContact() {
      let action = await ibb.addContact(this.accountHandle, this.name);
      if (!action.error.type) {
        this.$showSuccess(this.$t('sharedDrive.addContactCorrectly'));
      }
      this.fetchData();
    },
    async removeContact() {
      let action = await ibb.removeContact(this.contactHandle);
      if (!action.error.type) {
        this.$showSuccess(this.$t('sharedDrive.removeContactCorrectly'));
      } 
      this.fetchData();
    }
  }
};
</script>
